export const color = {
    white: '#fff',
    black: '#000',
    blacka10: '#0000001A',
    blacka20: '#00000033',
    blacka30: '#0000004D',
    blacka40: '#00000066',
    blacka50: '#00000080',
    blacka60: '#00000099',
    blacka70: '#000000B3',
    blacka80: '#000000CC',
    blacka90: '#000000E6',
    brand5: '#EBF5FF',
    brandBg: '#E8F4FF',
    brand10: '#E5F1FF',
    brand15: '#B2D7FF',
    brand20: '#67AEFFCC',
    brand25: '#67AEFF',
    brand30: '#1D85FF',
    brand40: '#0C76F7',
    brand50: '#0E64D3',
    brandColor: '#0E64D3',
    brand60: '#0950BD',
    brand70: '#073C8B',
    blue1: '#F1F5F9',
    blue5: '#EFF0F2',
    blue10: '#C7E0FF',
    blue20: '#8EC2FF',
    blue30: '#67AEFF',
    blue30a15: '#67AEFF26',
    blue40: '#3491FF',
    blue50: '#1D85FF',
    blue60: '#1067CD',
    gray5: '#F7F8FA',
    gray10: '#F7F7F9',
    gray15: '#F2F2F5',
    gray20: '#EBEBEF',
    gray25: '#D8D8DF',
    gray30: '#C5C5CE',
    gray35: '#B4B4C0',
    gray40: '#A1A1AF',
    gray45: '#9797A6',
    gray50: '#7A7A88',
    gray60: '#555562',
    gray70: '#383841',
    gray80: '#232328',
    gray90: '#141418',
    gray100: '#000000',
    red: '#DB0B24',
    brand: '#0E64D3',
    link: '#1067CD',
    lightOrange: '#FFA14B',
    orange: '#F67600',
    orange10: '#FDDDBF',
    orange20: '#FBBB80',
    orange30: '#FF9D0A',
    orange40: '#F67600',
    // 카메라 가이드/타이머 ON 컬러 (Figma 174:6964 등)
    yellow30: '#FFE500',
    yellow: '#FFD900',
    yellow70: '#FF9D0A',
    success: '#00E794',
    success10: '#E1FCF2',
    success30: '#12AC74',
    // iOS 시스템 색상
    iosBlue: '#007AFF',
    // 위치/지도 관련
    currentLocation: '#FF5722',
    // 위험/삭제 관련
    danger: '#dc3545',
    dangerBright: '#ff4444',
    // HomeScreenV2 redesign colors
    quickActionGreen: '#ecfadf',
    quickActionBlue: '#e3f0fd',
    gray80v2: '#24262b',
    gray50v2: '#767884',
    gray40v2: '#a0a2ae',
    gray90v2: '#16181c',
    gray60v2: '#585a64',
    gray20v2: '#e3e4e8',
    gray70v2: '#3a3c45',
    gray30v2: '#c3c5cc',
    gray15v2: '#f2f2f5',
    gray10v2: '#f7f8fa',
    // challenge-redesign 추가 색상 (Figma 5:7264, tailwind.config.js 와 1:1 대응)
    brand3: '#EFF6FF',
    gray19: '#EAEAEF',
    gray22: '#E7E8E9',
    gray46: '#9A9B9F',
    gray55: '#6A6A73',
    gray85: '#1E1E1E',
};
